import { FC, useContext, useEffect, useState } from 'react';
import { getRandomImage, getWorkingHours } from 'services/config';
import { cdnUrl } from 'constants/generic';
import { WorkingHoursData } from 'ts/interfaces/Generic';
import ContactCenter from './ContactCenter';
import { useLocation } from 'react-router-dom';
import MultiSearchBox from './MultiSearchBox';
import { useTranslation } from 'react-i18next';
import { MainContext } from 'contexts/MainContext';

interface MainCustomageProps {
  isEnigma: boolean;
}
const MainCustomage: FC<MainCustomageProps> = ({ isEnigma, ...props }) => {
  const [workingHours, setWorkingHours] = useState<WorkingHoursData>();
  const location = useLocation();
  const [bgImage, setBgImage] = useState<{ backgroundImage: string }>();
  const { initSiteData } = useContext(MainContext);
  const newsImg = initSiteData?.other?.newsImg || '';
  const { i18n } = useTranslation();

  useEffect(() => {
    (async () => {
      const data = await getWorkingHours(i18n.language);
      if (data?.officeInformation) {
        const json = JSON.parse(data.officeInformation);
        setWorkingHours(json);
      } else {
        setWorkingHours(undefined);
      }
    })();
  }, [i18n.language]);

  useEffect(() => {
    (async () => {
      if (!isEnigma) {
        const response = await getRandomImage();
        setBgImage({ backgroundImage: `url(${cdnUrl + response?.imageUrl})` });
      }
      const data = await getWorkingHours(i18n.language);
      try {
        const workingHours = JSON.parse(data.officeInformation);
        setWorkingHours(workingHours);
      } catch (e) {}
    })();
  }, [location.pathname]); // eslint-disable-line

  return (
    <div className="display-flex">
      <section className="main-page hotels" style={bgImage}>
        {newsImg && (
          <div className="news-img">
            <div>צוות תמיכה</div>
            <img src={newsImg} alt="news" />
          </div>
        )}
        <MultiSearchBox />
        {workingHours && (
          <div className="contact-center-wr">
            <ContactCenter workingHours={workingHours} />
          </div>
        )}
      </section>
    </div>
  );
};

export default MainCustomage;
